
import moment from 'moment';
import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { BsCalendarCheck } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import {  useParams } from 'react-router-dom';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { SocialIcon } from 'react-social-icons';
import BannerImageAd from '../../Component/BannerImageAd';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import HeadingWithUnderline from '../../Component/HeadingWithUnderline';
import { Loader } from '../../Component/Loader';
import { imageUrl } from '../../config/apiUrl';
import { useLazyGetApiQuery } from '../../store/apiSlice/apiSlice';
import classes from './BlogDetail.module.css';
import parse from 'html-react-parser';


const BlogDetail = () => {
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { allBanners } = useSelector((state) => state.commonReducer);
  const slug = useParams()?.slug;

  const [getApiFunc, { isLoading, data: response, isFetching }] = useLazyGetApiQuery();

  const horizontalBanner = allBanners?.find(
    (item) => item?.page === 'blog-detail' && item?.bannerType == 'horizontal'
  );

  const getData = async () => {
    await getApiFunc({
      url: `blog/${slug}`,
      tag: `Blogs`
    });
  };

  useEffect(() => {
    getData();
  }, [slug]);

  const blogData = response?.data;
  const url = window.location.href;

  return (
    <div className={classes.page}>
      <Header containerClass="" />
      <Container className="">
        {isLoading || isFetching ? (
          <Loader />
        ) : (
          <Row className={[classes.row].join(' ')}>
            {/* Featured Prop */}
            <Col md={12}>
              <HeadingWithUnderline
                underlineColor={'transparent'}
                className={classes.sectionHeading}>
                <h2>{t('blogs.detailTitle')}</h2>
              </HeadingWithUnderline>
            </Col>
            <Col md={12}>
              <div className={classes?.detailMainContainer}>
                <div className={classes?.data}>
                  <BsCalendarCheck fill="#cccccc" size={20} />
                  <p>{moment(blogData?.createdAt).format('DDMMM,YYYY')}</p>
                </div>
                <div className={classes?.detailContainers}>
                  <h6>{blogData?.title?.[selectedLanguage]}</h6>
                </div>
                <div className={classes?.imageContainer}>
                  <img 
                  
                  alt={blogData?.image}
                  draggable={false}
                  src={imageUrl(blogData?.image)} />
                </div>
                <div className={classes?.detailContainer}>
                  {/* <h6>{blogData?.title?.[selectedLanguage]}</h6> */}
                  <p>
                    {blogData?.description?.[selectedLanguage] &&
                      parse(blogData?.description?.[selectedLanguage])}
                  </p>
                </div>
                <div className={classes?.bottomContainer}>
                  <div className={classes?.socialIconContainer}>
                    <p>{t('blogs.share')}</p>

                    <TwitterShareButton url={url}>
                      <SocialIcon
                        url="https://twitter.com"
                        className={classes?.socialIcon}
                        fgColor="#484848"
                      />
                    </TwitterShareButton>
                    <FacebookShareButton url={url}>
                      <SocialIcon
                        url="https://facebook.com"
                        className={classes?.socialIcon}
                        fgColor="#484848"
                      />
                    </FacebookShareButton>
                    <WhatsappShareButton url={url}>
                      <SocialIcon
                        url="https://web.whatsapp.com"
                        className={classes?.socialIcon}
                        fgColor="#484848"
                      />
                    </WhatsappShareButton>
                  </div>
                  <div className={classes?.authorContainer}>
                    <BsCalendarCheck fill="#cccccc" size={20} />
                    <p>{moment(blogData?.createdAt).format('DDMMM,YYYY')}</p>
                  </div>
                </div>
              </div>
            </Col>
            {/* <Col md={4}>
              <div className={classes?.tabsWrapper}>
                <Tabs
                  tabsData={[{ id: 1, text: t('blogs.tab1') }]}
                  value={{ id: 1, text: t('blogs.tab1') }}
                  setValue={() => {}}
                  className={classes?.tabsContainer}
                  scrollOffset={150}
                />
              </div>

              <div className={classes?.itemsContainer}>
                {response?.latestBlog?.slice(0, 3).map((item, index) => (
                  <BlogTitleCard key={index} data={item} />
                ))}
              </div>
              <div className={classes?.tabsWrapper}>
                <Tabs
                  tabsData={[{ id: 1, text: t('blogs.tab2') }]}
                  value={{ id: 1, text: t('blogs.tab2') }}
                  setValue={() => {}}
                  className={classes?.tabsContainer}
                  scrollOffset={150}
                />
              </div>
              <div className={classes?.itemsContainer}>
                {response?.popularBlog?.slice(0, 3).map((item, index) => (
                  <BlogTitleCard key={index} data={item} />
                ))}
              </div>
            </Col> */}
            <Col md={12}>
              {horizontalBanner?.image && (
                <BannerImageAd
                  link={horizontalBanner?.link}
                  image={imageUrl(horizontalBanner?.image)}
                  className={`bannerHorizontal ${classes.banner}`}
                />
              )}
            </Col>
          </Row>
        )}
      </Container>
      <Footer showDownload={false} />
    </div>
  );
};

export default BlogDetail;
